import {type QuerySegment, tokenizeQuery} from '@github-ui/filter-query'
import {Truncate} from '@primer/react'
import React from 'react'

import styles from './TokenizedQuery.module.css'

export function TokenizedQuery({className, query}: {className?: string; query: string}) {
  const segments = tokenizeQuery(query)

  return (
    <Truncate className={className} maxWidth="100%" title={query} inline>
      {segments.map((segment, index) => {
        if (segment.type === 'text') {
          return (
            // eslint-disable-next-line @eslint-react/no-array-index-key -- key+value can still be duplicated on the query
            <Token key={index} isFirst={index === 0}>
              {segment.value}
            </Token>
          )
        } else {
          // eslint-disable-next-line @eslint-react/no-array-index-key -- key+value can still be duplicated on the query
          return <FilterToken key={index} isFirst={index === 0} segment={segment} />
        }
      })}
    </Truncate>
  )
}

function FilterToken({isFirst, segment}: {isFirst: boolean; segment: Extract<QuerySegment, {type: 'filter'}>}) {
  return (
    <Token isFirst={isFirst}>
      {segment.isNegated ? '-' : ''}
      {segment.key}:
      {segment.quotedValues.map((value, index) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key -- key+value can still be duplicated on the query
        <React.Fragment key={index}>
          {index > 0 && ','}
          <span className={styles.Token}>{value}</span>
        </React.Fragment>
      ))}
    </Token>
  )
}

function Token({isFirst, children}: {isFirst: boolean; children: React.ReactNode}) {
  return (
    <span>
      {!isFirst && ' '}
      {children}
    </span>
  )
}

try{ TokenizedQuery.displayName ||= 'TokenizedQuery' } catch {}
try{ FilterToken.displayName ||= 'FilterToken' } catch {}
try{ Token.displayName ||= 'Token' } catch {}